// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from '../../common/api'
import { MASTER_LIST, COUNTRY, STATE, CITY, GET_PERMISSION, PERMISSION_ADD } from '../../common/constant'

export const actionMasterList = createAsyncThunk('appCommon/actionMasterList', async (params, thunkAPI) => {
    return await post(MASTER_LIST, params, thunkAPI)
})

export const actionCountry = createAsyncThunk('appCommon/actionCountry', async (params, thunkAPI) => {
    return await post(COUNTRY, params, thunkAPI)
})

export const actionState = createAsyncThunk('appCommon/actionState', async (params, thunkAPI) => {
    return await post(STATE, params, thunkAPI)
})

export const actionCity = createAsyncThunk('appCommon/actionCity', async (params, thunkAPI) => {
    return await post(CITY, params, thunkAPI)
})

export const actionGetPermission = createAsyncThunk('appCommon/actionGetPermission', async (params, thunkAPI) => {
    return await post(GET_PERMISSION, params, thunkAPI)
})

export const actionPermissionAdd = createAsyncThunk('appCommon/actionPermissionAdd', async (params, thunkAPI) => {
    return await post(PERMISSION_ADD, params, thunkAPI)
})

export const appCommonSlice = createSlice({
    name: 'appCommon',
    initialState: {
        //list
        loadingMasterList: false,
        masterList: null,

        //country
        loading: false,
        country: null,

        //state
        loadingState: false,
        state: null,

        //city
        loadingCity: false,
        city: null,

        //get permission
        loadingGetPermission: false,
        permission: null,

        //add permission
        loadingPermissionAdd: false,
        permissionAdd: null
    },

    reducers: {
        //reset or delete Client store data
        resetMasterListResponse: (state) => {
            state.masterList = null
        },
        resetCountryResponse: (state) => {
            state.country = null
        },
        resetStateResponse: (state) => {
            state.state = null
        },
        resetCityResponse: (state) => {
            state.city = null
        },
        resetGetPermissionResponse: (state) => {
            state.permission = null
        },
        resetPermissionAddResponse: (state) => {
            state.permissionAdd = null
        }
    },

    extraReducers: builder => {
        builder
            //list
            .addCase(actionMasterList.pending, (state) => {
                state.loadingMasterList = true
            })
            .addCase(actionMasterList.fulfilled, (state, action) => {
                state.loadingMasterList = false
                state.masterList = action.payload
            })
            .addCase(actionMasterList.rejected, (state) => {
                state.loadingMasterList = false
            })

            //country
            .addCase(actionCountry.pending, (state) => {
                state.loading = true
            })
            .addCase(actionCountry.fulfilled, (state, action) => {
                state.loading = false
                state.country = action.payload
            })
            .addCase(actionCountry.rejected, (state) => {
                state.loading = false
            })

            //state
            .addCase(actionState.pending, (state) => {
                state.loadingState = true
            })
            .addCase(actionState.fulfilled, (state, action) => {
                state.loadingState = false
                state.state = action.payload
            })
            .addCase(actionState.rejected, (state) => {
                state.loadingState = false
            })

            //state
            .addCase(actionCity.pending, (state) => {
                state.loadingCity = true
            })
            .addCase(actionCity.fulfilled, (state, action) => {
                state.loadingCity = false
                state.city = action.payload
            })
            .addCase(actionCity.rejected, (state) => {
                state.loadingCity = false
            })

            //get permission
            .addCase(actionGetPermission.pending, (state) => {
                state.loadingGetPermission = true
            })
            .addCase(actionGetPermission.fulfilled, (state, action) => {
                state.loadingGetPermission = false
                state.permission = action.payload
            })
            .addCase(actionGetPermission.rejected, (state) => {
                state.loadingGetPermission = false
            })

            //add permission
            .addCase(actionPermissionAdd.pending, (state) => {
                state.loadingPermissionAdd = true
            })
            .addCase(actionPermissionAdd.fulfilled, (state, action) => {
                state.loadingPermissionAdd = false
                state.permissionAdd = action.payload
            })
            .addCase(actionPermissionAdd.rejected, (state) => {
                state.loadingPermissionAdd = false
            })
    }
})
export const { resetMasterListResponse, resetCountryResponse, resetStateResponse, resetCityResponse, resetGetPermissionResponse, resetPermissionAddResponse } = appCommonSlice.actions

export default appCommonSlice.reducer